import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import ShapeTwo from '../../components/shape-two'
import Accordion from '../../components/accordion'
import AccordionTwo from '../../components/accordion-two'
import Shape from '../../components/shape'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/bg.jpg'

export default function HelpFaq() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">F.A.Q.</h4>
                          <p className="text-muted mb-0">General and business related question and answer are here,</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li>
                          <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Help Center</Link></li>
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">F.A.Q.</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>

    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-lg-8 col-md-10">
                  <div className="section-title">
                      <h4 className="title mb-4">General Questions :</h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <AccordionTwo/>
                  </div>
              </div>
          </div>

          <div className="row mt-5 justify-content-center">
              <div className="col-lg-8 col-md-10">
                  <div className="section-title">
                      <h4 className="title mb-4">Working Questions :</h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <Accordion/>
                  </div>
              </div>
          </div>

          <div className="row mt-5 justify-content-center">
              <div className="col-lg-8 col-md-10">
                  <div className="section-title">
                      <h4 className="title mb-4">Send Your Questions :</h4>
                      <p className="text-muted para-desc">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>

                      <form className="mt-4">
                          <div className="row">
                              <div className="col-md-6">
                                  <div className="mb-3">
                                      <label className="form-label">Your Name <span className="text-danger">*</span></label>
                                      <input name="name" id="name" type="text" className="form-control" placeholder="Your Name :"/>
                                  </div>
                              </div>
                              <div className="col-md-6">
                                  <div className="mb-3">
                                      <label className="form-label">Your Email <span className="text-danger">*</span></label>
                                      <input name="email" id="email" type="email" className="form-control" placeholder="Your email :"/>
                                  </div> 
                              </div>
                              <div className="col-md-12">
                                  <div className="mb-3">
                                      <label className="form-label">Send Your Questions</label>
                                      <textarea name="question" id="question" rows="4" className="form-control" placeholder="Your Question :"></textarea>
                                  </div>
                              </div>
                          </div>
                          <div className="row">
                              <div className="col-sm-12 text-center">
                                  <div className="d-grid">
                                      <input type="submit" id="sendquestion" name="send" className="btn btn-primary" value="Send Question"/>
                                  </div>
                              </div>
                          </div>
                      </form> 
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
